import script from "./EventManageLink.vue?vue&type=script&setup=true&lang=js"
export * from "./EventManageLink.vue?vue&type=script&setup=true&lang=js"

import "./EventManageLink.vue?vue&type=style&index=0&id=809d89ac&lang=css"

const __exports__ = script;

export default __exports__